<template>
<!-- 예스코인 메인 대시보드 -->
    <section class="yescoin-mainboard">
        <div class="yescoin-manege position-relative">
            <!-- <button type="button" @click="showYescoinManageMenu" aria-label="예스코인 관리 메뉴 보기">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM11 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <ul v-if="yescoinManageMenu" class="yescoin-menu position-absolute">
                <li><button type="button" @click="showBankAccountLayerPopup" :href="`#popup1`">계좌관리</button></li>
            </ul> -->
            <template v-if="Number(vuexYescoinAmt) > 0">
                <router-link :to="{name:'refund'}" @click.native="checkCurrentYescoinAmt">
                    <span class="margin-r-4">환불 신청</span>
                    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L1.70711 0.292893ZM5 5L5.70711 5.70711C6.09763 5.31658 6.09763 4.68342 5.70711 4.29289L5 5ZM0.292893 8.29289C-0.0976311 8.68342 -0.0976311 9.31658 0.292893 9.70711C0.683417 10.0976 1.31658 10.0976 1.70711 9.70711L0.292893 8.29289ZM0.292893 1.70711L4.29289 5.70711L5.70711 4.29289L1.70711 0.292893L0.292893 1.70711ZM4.29289 4.29289L0.292893 8.29289L1.70711 9.70711L5.70711 5.70711L4.29289 4.29289Z" fill="white"/>
                    </svg>
                </router-link>
            </template>
        </div>
        <div class="yescoin-balance">
            <i class="balance">{{Number(vuexYescoinAmt).toLocaleString()}}</i>원
        </div>
        <div class="btns">
            <template v-if="getWaitingRefundInfoCnt > 0">
                <button type="button" class="btn-m btn-wht-l" @click="showWaitingRefundToastPopup">환불진행 내역 {{getWaitingRefundInfoCnt}}건</button>
            </template>
            <template v-if="vuexVaWaitingCnt > 0">
                <button type="button" class="btn-m btn-wht color-primary" @click="showWaitingVaDepositToastPopup">가상계좌 입금대기</button>
            </template>
            <template v-if="vuexVaWaitingCnt === 0">
                <button type="button" class="btn-m btn-wht color-primary" @click="showChargingLayerPopup">충전</button>
            </template>
        </div>
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { copyToClipBoard } from '@/util';

export default {
    data() {
        return{
            yescoinManageMenu: false,       // 메뉴 더보기 노출 (계좌관리, 환불 요청 등 메뉴)
            virtualBankBrand: '',           // 가상계좌 은행명
            virtualBankAccountNum: '',      // 가상계좌 계좌번호
            virtualAccountHolder: '',       // 가상계좌 예금주            
            // coinBalance: null,           // 코인 잔액
            // awaitingRefundCnt: 0,           // 환불진행 건 카운트
            uriName: '',                    // URI 이름

            getWaitingVaDepositInfoCnt: 0,    // 가상계좌 입금 안내건 카운트
        }
    },

    computed: {
        ...mapState({
            userNo: state => state.userNo,
            vuexRefundYescoinWaitingInfoList: state => state.refundStore.vuexRefundYescoinWaitingInfoList,
            vuexYescoinAmt: state => state.yescoinStore.vuexYescoinAmt,
            vuexVaWaitingList: state => state.yescoinStore.vuexVaWaitingList,
            vuexVaWaitingCnt: state => state.yescoinStore.vuexVaWaitingCnt,
        }),

        ...mapGetters({
            getWaitingRefundInfoCnt:'refundStore/getWaitingRefundInfoCnt',
        }),
    },

    mounted() {
        this.uriName = this.$route.query.name;
    },

    watch: {
        // URI 쿼리 값이 일치하면 해당 팝업 노출
        // uriName(){
        //     switch (this.uriName){
        //         case 'wating-refund':   // 환불진행내역
        //             this.showWaitingRefundToastPopup();
        //             break;
        //         case 'wating-vaDeposit':   // 가상계좌 입금진행내역
        //             this.showWaitingVaDepositToastPopup();
        //             break;
        //         case 'charging':        // 충전
        //             this.showChargingLayerPopup();
        //             break;
        //     }
        // }
    },

    methods: {
        // 환불신청페이지로 넘어가기 전 예스코인잔액 체크
        checkCurrentYescoinAmt() {
            if(this.vuexYescoinAmt <= 0) {
                alert('환불신청이 가능한 예스코인 잔액이 없습니다.');
                this.$router.push({name:"home"});
            }
        },

        // 텍스트 복사하기 버튼 기능
        virtualCopyToClipBoard(){
            const bankaccount = `${this.virtualBankBrand} ${this.virtualBankAccountNum}`;
            copyToClipBoard(bankaccount);
        },

        // 가상계좌 입금진행 내역 팝업 컴포넌트 노출
        showWaitingVaDepositToastPopup(){
            this.$store.commit('modalStore/setVisibleWaitingVaDepositToastPopup', true);
            // this.addURIQuery('wating-vaDeposit');
        },

        // 환불진행 내역 팝업 컴포넌트 노출
        showWaitingRefundToastPopup(){
            this.$store.commit('modalStore/setVisibleWaitingRefundToastPopup', true);
            // this.addURIQuery('wating-refund');
        },

        // 충전 팝업 컴포넌트 노출
        showChargingLayerPopup(){
            this.$store.commit('modalStore/setVisibleChargingLayerPopup', true);
            // this.replaceURIQuery('charging');
        },

        // URI 파라미터 쿼리 추가 Stack 쌓임(뒤로가기 API 사용 가능)
        // addURIQuery(popupHash){
        //     this.$router
        //         .push({
        //             name:"yescoin", 
        //             query: {name: popupHash}
        //         })
        //         .catch(
        //             ()=>{} // 같은 페이지 내에서 다시 이동할 때 발생하는 오류 메시지를 무시한다.
        //         );
        // },
        
        // // URI 파라미터 쿼리 대체 Stack 쌓임(뒤로가기 API 사용 불가)
        // replaceURIQuery(popupHash){
        //     this.$router
        //         .replace({
        //             name:"yescoin", 
        //             query: {name: popupHash}
        //         })
        //         .catch(
        //             ()=>{} // 같은 페이지 내에서 다시 이동할 때 발생하는 오류 메시지를 무시한다.
        //         );
        // },

        // // (사용안함) 환불 문의 안내 팝업 컴포넌트 노출
        // showRefundNoticeToastPopup(){
        //     this.$store.$commit('modalStore/setVisibleRefundNoticeToastPopup', true);
        //     this.resetVisibleMenu();
        // },

        // // 관리 메뉴 노출 기능
        // showYescoinManageMenu(){
        //     this.yescoinManageMenu = !this.yescoinManageMenu;
        // },

        // // 관리 메뉴 노출 초기화
        // resetVisibleMenu(){
        //     this.yescoinManageMenu = false;
        // },
    },
}
</script>

<style lang="scss" scoped>

.yescoin-mainboard{
    text-align: center;
    border-radius: var(--border-radius);
    background-image: linear-gradient(to right, #0047ff -17%, #c2a5ff 115%);
    color: var(--white);
    padding: 16px;
    @media (min-width: 768px) {
        padding: 20px;
    }
    @media (min-width: 1200px) {
        padding: 25px;
    }

    .yescoin-manege{
        text-align: right;

        .yescoin-menu{
            right: 8px;
            top: calc(25px + 4px);
            background: var(--white);
            border-radius: var(--border-radius);
            padding: var(--compo-form-pdx);
            color: var(--black);
            display: inline-flex;
            flex-direction: column;
            gap: 8px;
            line-height: 1;
        }

    }

    .virtual-account{
        display: inline-flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
    }
    .yescoin-balance{
        margin-bottom: 32px;
        font-weight: 500;
        font-size: 28px;
        .balance{
            font-weight: 600;
            font-size: 36px;
        }
        @media (min-width: 1200px) {
            font-size: 36px;
            .balance{
                font-weight: 700;
                font-size: 40px;
            }
        }
    }

    .btns{
        text-align: center;
        justify-content: center;

        button{
            font-weight: 500;
            max-width: 144px;
            @media (min-width: 768px) {
                max-width: 300px;
            }
        }
    }
}
</style>